"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merge_1 = __importDefault(require("lodash/merge"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_image_1 = require("@hotelplan/components.common.image");
const components_common_link_1 = require("@hotelplan/components.common.link");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const BrandLogosWrap = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    width: ['100%', 'auto'],
    borderBottom: ['1px solid', 'none'],
    borderColor: 'borderColor',
    lineHeight: ['1', 'inherit'],
    alignItems: 'center',
    justifyContent: ['center', 'space-between'],
}), ({ theme }) => theme.brandLogos.items);
const BrandImageLink = (0, styled_components_1.default)(components_common_link_1.Link)({
    height: '40px',
    textAlign: 'center',
    transition: 'fast',
    fontSize: 0,
    letterSpacing: 'initial',
}, ({ link, theme, theme: { colors } }) => (0, merge_1.default)({}, {
    '&:hover': link
        ? {
            borderColor: colors.primary,
        }
        : {},
}, theme.brandLogos.imageLink));
const BrandImage = (0, styled_components_1.default)(components_common_image_1.Image)(({ theme: { media } }) => ({
    width: '100%',
    height: '100%',
    maxHeight: '40px',
    objectFit: 'contain',
    [media.tablet]: {
        width: 'auto',
    },
}));
const BrandLogos = ({ brandLogos, className }) => {
    return brandLogos.length !== 0 ? (react_1.default.createElement(BrandLogosWrap, { className: className }, brandLogos.map((item, index) => {
        const link = item.link ? (0, libs_router_link_utils_1.getRouterLink)(item.link) : undefined;
        return ((children) => link ? (react_1.default.createElement(components_common_router_link_1.RouterLink, Object.assign({ key: `${item.iconId}_${index}` }, link, { passHref: true }), children)) : (children))(react_1.default.createElement(BrandImageLink, { key: `link-${index}`, target: item.link ? (0, libs_router_link_utils_1.getOpenMethod)(item.link) : undefined, link: item.link, "data-id": item.link ? 'brand-logo-link-id' : 'brand-logo-id', onClick: item.link ? undefined : e => e.preventDefault(), className: "brand-link" },
            react_1.default.createElement(BrandImage, Object.assign({ className: "brand-image" }, item.icon)),
            item.caption));
    }))) : null;
};
exports.default = BrandLogos;
//# sourceMappingURL=BrandLogos.js.map